<template>
  <b-modal
    id="add-update-slider-modal"
    size="lg"
    :ok-title="`${editing ? 'Update': 'Add'} Slider`"
    cancel-variant="outline-danger"
    @ok="addSlider"
    @hide="()=>{$emit('close'); image=null}"
    @close="()=>{$emit('close'); image=null}"
  >
    <b-row>
      <validation-observer ref="sliderForm">
        <b-col cols="12">
          <validation-provider
            #default="{errors}"
            name="Slider Title"
            rules="required"
          >
            <b-form-group label="Slider Title">
              <b-form-input
                v-model="form.title"
                type="text"
                placeholder="Slider Title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <b-form-group
            v-if="slider"
            label="Slider Image"
          >
            <custom-image-upload
              height="300"
              :url="image || getStorage(slider.image)"
              @imageUploaded="(img,url)=>{image = url }"
              @imageRemoved="()=>{
                form.image = null
              }"
            />
          </b-form-group>

          <validation-provider
            #default="{errors}"
            name="Description"
            rules="required"
          >
            <b-form-group label="Description">
              <quill-editor
                ref="myQuillEditor"
                v-model="form.description"
                :options="editorOption"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </validation-observer>
    </b-row>
  </b-modal>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.core.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate/dist/vee-validate.full'
import {
  BModal, BRow, BCol, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import useApollo from '@/plugins/graphql/useApollo'
import CustomImageUpload from '../CustomImageUpload.vue'

export default {
  components: {
    quillEditor,
    ValidationObserver,
    ValidationProvider,
    CustomImageUpload,
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
  },

  props: {
    slider: {
      type: [Array, Object],
      default: () => {},
    },
    editing: {
      type: [String, Boolean],
      default: false,
    },
  },

  data() {
    return {
      form: {},
      editorOption: {
        placeholder: 'Please write some description about slider',
      },
      image: null,
    }
  },

  watch: {
    slider(value) {
      this.form = value
    },
  },

  methods: {
    addSlider() {
      const projectUid = this.$store.state.project.selectedProject
      if (this.editing) {
        const { id, __typename, ...form } = this.form
        if (this.image) form.image = this.image
        const formattedData = {
          input: { ...form, id: this.slider.id },
          projectUid,
        }

        return useApollo.cms.updateSlider(formattedData).then(() => {
          this.showSuccess('Slider Updated Successfully')
        }).finally(() => {
          this.$emit('success')
          this.$bvModal.hide('add-update-slider-modal')
        })
      }

      this.form.image = this.image
      return useApollo.cms.createSlider({ input: this.form, projectUid }).then(() => {
        this.showSuccess('Slider Updated Successfully')
      }).finally(() => {
        this.$emit('success')
        this.$bvModal.hide('add-update-slider-modal')
      })
    },
  },
}
</script>
<style lang="scss">

#add-update-slider-modal {
  .modal-content {
    min-height: 400px;
  }
  .ql-editor {
    min-height: 200px;
  }
}

.dark-layout {
    .ql-snow {
      .ql-stroke {
        stroke: #a6a6a6;
      }
      .ql-fill {
        fill: #a6a6a6;
      }
      .ql-picker-label {
        color: #a6a6a6;
      }
    }
  }
</style>
